import { render, staticRenderFns } from "./TmallConf.vue?vue&type=template&id=2479d6b0&scoped=true"
import script from "./TmallConf.vue?vue&type=script&lang=js"
export * from "./TmallConf.vue?vue&type=script&lang=js"
import style0 from "./TmallConf.vue?vue&type=style&index=0&id=2479d6b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2479d6b0",
  null
  
)

export default component.exports